import '@babel/polyfill';
import {TweenMax, TimelineMax } from "gsap";
import ScrollMagic from 'scrollmagic';
import 'imports-loader?define=>false!scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';


function scrollSections() {
    const homeSection = document.querySelector('#section-home-intro');
    const homePageFader = document.querySelector('.hope-page-fader');
    const mainHomeTitleWrapper = document.querySelector('.header-logo-title');
    const homePageArticleText = document.querySelector('.home-text-intro');
    const bettingDirectorySection = document.querySelector('#betting-directory');
    const windowHeight = window.innerHeight;
    
    const sectionTopHeader = document.querySelector('.betting-directory-header-pinned');
    const parallaxBettingsSection = document.querySelector('.parallax-articles');
    const parallaxBettingsSectionHeight = parallaxBettingsSection.offsetHeight;
    const headerHeight = sectionTopHeader.offsetHeight;

    const horseRacingSecondSection = document.getElementById('horse-racing2');
    const horseRacingHeader = document.querySelector('.horse-racing-header-pinned');
    const horseRacingLogoText = document.querySelector('.horse-racing-logo-wrapper');
    const footballPinnedHeader = document.querySelector('.football-header-pinned');
    const pinnedHeaderDogs = document.querySelector('.dogs-header-pinned');
    const dogsRacingLogo = document.querySelector('.logo-dogs-section');
    const dogsSectionBanner = document.querySelector('.dogsBcg.bcg-section');
    const dogsSection = document.querySelector('#dog-racing-section');
    const coachesSectionpinnedHeader = document.querySelector('#sack-race-section > .sack-header-pinned');
    const coachesbannerFader = document.querySelector('.bcg-image-fader');
    const oddsPinnedHeader = document.querySelector('#odds-section > .section-top-header');
    const oddsSection = document.querySelector('#odds-section');
    const oddsCommingSoonTitle = document.querySelector('#odds-section .logo-wrapper');

    const controller = new ScrollMagic.Controller();

    const handleScrollHomeSection = () => {
        if(!Modernizr.touch) {

             // Home page intro scrolling
            let pinHomeSectionTween = new TimelineMax();
            const addClassOnComplete = () => {
                homePageArticleText.classList.add('visible-text');
            }
            pinHomeSectionTween

                .to(homePageFader, 1.5, {
                    autoAlpha:0,
                })
                .to(mainHomeTitleWrapper, 0.8, {opacity: 0, 
                    yPercent: -60
                }, 
                '0')
                .from(homePageArticleText, 1, {autoAlpha: 0, 
                    yPercent: 50,
                    onStart: addClassOnComplete(),
                });
                
           
            let scene1 = new ScrollMagic.Scene({
                triggerElement: homeSection, 
                triggerHook: 0,
                duration: "50%"
            })
                .setPin(homeSection)
                .setTween(pinHomeSectionTween)
                .addTo(controller);

             // Betting directory section
                const sceneBettingDirectory = new ScrollMagic.Scene({
                    triggerElement: bettingDirectorySection, 
                    triggerHook: 0,
                    duration: "100%",
                })
                    .setPin(sectionTopHeader, {
                        pushFollowers: false
                    })
                    .addTo(controller);

                // Horse Racing scrolling sections
                const pinnedHorseRacingHeader = new ScrollMagic.Scene({
                    triggerElement: horseRacingHeader,
                    triggerHook: 0,
                    duration: "100%",
                }).setPin(horseRacingHeader, {
                    pushFollowers: false
                })
                .addTo(controller);

                const parallaxHorseRacingTextLogo = new TimelineMax();
                parallaxHorseRacingTextLogo
                    .from(horseRacingLogoText, 2, {autoAlpha: 0, 
                        yPercent: 20,
                        // onStart: addClassOnComplete(),
                    });
                
                    const logoTextScene = new ScrollMagic.Scene({
                        triggerElement: horseRacingSecondSection,
                        triggerHook: 0,
                        duration: "40%",
                        offset:"-200",
                    })
                    .setTween(parallaxHorseRacingTextLogo)
                    .addTo(controller)

                    // Odds section

                    const oddsTitleTween = TweenMax.fromTo(oddsCommingSoonTitle, 2,
                        {
                            autoAlpha:0,
                        },
                        {
                            autoAlpha:1,
                        }
                    );

                    // oddsPinnedHeader

                        const oddsScene = new ScrollMagic.Scene({
                            triggerElement: oddsSection,
                            duration: '100%',
                            offset: 0
                        })
                        .setTween(oddsTitleTween)
                        .addTo(controller);


                    const oddsSectionScene = new ScrollMagic.Scene({
                        triggerElement: oddsPinnedHeader,
                        triggerHook: 0,
                        duration: 150
                    }).setPin(oddsPinnedHeader, {
                        pushFollowers: false
                    })
                    .addTo(controller)


                    // Dogs section parallax
            
                    const dogsLogoTween = TweenMax.fromTo(dogsRacingLogo, 2,
                        {
                            autoAlpha:0,
                        },
                        {
                            autoAlpha:1,
                        }
                    );
                    const dogsLogoScene = new ScrollMagic.Scene({
                        triggerElement: dogsSection,
                        duration: "100%",
                    })
                    .setTween(dogsLogoTween)
                    .addTo(controller);

                    const dogsSectionScene = new ScrollMagic.Scene({
                        triggerElement: pinnedHeaderDogs,
                        triggerHook: 0,
                        duration: 150
                    }).setPin(pinnedHeaderDogs, {
                        pushFollowers: false
                    })
                    .addTo(controller)

                    // Coaches section
                    const faderTween = new TimelineMax();
                    faderTween
                        .to(coachesbannerFader,1,{
                            autoAlpha: 0,
                        })
                    const coachesSectionScene = new ScrollMagic.Scene({
                        triggerElement: coachesSectionpinnedHeader,
                        triggerHook: 0,
                        duration: "50%"
                    }).setPin(coachesSectionpinnedHeader, {
                        pushFollowers: false
                    })
                    .setTween(faderTween)
                    .addTo(controller)

                    // Football section parallax

                    const footballSectionScene = new ScrollMagic.Scene({
                        triggerElement: footballPinnedHeader,
                        triggerHook: 0,
                        duration: "20%",
                    }).setPin(footballPinnedHeader, {
                        pushFollowers: false
                    })
                    .addTo(controller)

                    controller.scrollTo(function (newpos) {
                        TweenMax.to(window, 1, {scrollTo: {y: newpos}, ease:Power1.easeInOut});
                    });

               
        } // End of modernizr conditional
    }

    handleScrollHomeSection();
}

export default scrollSections;